import Cookies from 'js-cookie';
import { getWidgetLocation } from 'utils';

export const isWithdrawalRejectBilletClosedCookieSet = (): boolean =>
  Boolean(Cookies.get('withdrawalRejectBilletClosed'));

export const setWithdrawalRejectBilletClosedCookies = (): void => {
  Cookies.set('withdrawalRejectBilletClosed', '1', {
    expires: 3, // days
    secure: true, // because without this parameter (true) - cookie do not set in iFrame
    sameSite: 'none',
  });
};

export const isPathnameOkForWithdrawalReject = (pathname: string): boolean => {
  const { isDeposit, isDepositForm } = getWidgetLocation(pathname);

  return isDeposit || isDepositForm;
};
